<template>
    <v-layout justify-center>
        <v-responsive max-width="1080" width="100%" height="100%" class="px-3 mx-n3">
            <list-heading title="채용공고 목록" v-model="showsSearch" showsFilterButton />

            <recruitment-list-search v-bind="{ showsSearch }" />

            <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" style="overflow: hidden">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <template #[`item.company`]="{ value }">
                    <span> {{ value?.name || "-" }} ({{ value?.username || "-" }}) </span>
                </template>
                <template #[`item.subject`]="{ item, value }">
                    <v-list-item :href="`/recruitments/${item._id}`">
                        <v-list-item-content>
                            <v-list-item-subtitle class="text-truncate"> {{ item.host?.name }} </v-list-item-subtitle>
                            <v-list-item-title class="text-truncate"> {{ value }} </v-list-item-title>
                            <p class="mt-2 mb-0 text-truncate">{{ item.summary }}</p>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <template #[`item.state`]="{ item }">
                    <v-select
                        v-model="item.state"
                        v-bind="{
                            ...attrs_input__verticalTable,
                            items: states,
                        }"
                        class="text-caption"
                        @input="(state) => update({ _id: item._id, state })"
                    />
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn x-small fab text icon tile :to="`/console/recruitment/list/${item._id}/statistics`">
                        <v-icon>mdi-chart-line</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="mt-2" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { RECRUITMENT_STATES } from "@/assets/variables/constants";
import { attrs_input__verticalTable, attrs_switch__console } from "@/assets/variables/attrs";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import RecruitmentListSearch from "@/components/console/recruitment/list/recruitment-list-search.vue";

const states = Object.values(RECRUITMENT_STATES);

export default {
    components: {
        ListHeading,
        RecruitmentListSearch,
    },
    data: () => ({
        recruitments: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        showsSearch: true,

        states,
        attrs_input__verticalTable,
        attrs_switch__console,
    }),
    computed: {
        items() {
            return [...this.recruitments];
        },
        headers() {
            return [
                {
                    width: +60,
                    text: "#",
                    value: "index",
                    align: "end",
                },
                {
                    width: 160,
                    text: "사용자",
                    value: "company",
                    cellClass: "text-truncate max-width-0",
                },
                {
                    text: "공고",
                    value: "subject",
                    cellClass: "text-truncate max-width-0 px-0",
                },
                {
                    width: 100,
                    text: "생성일시",
                    value: "createdAt",
                    formatter: (value) => value?.toDateTime?.(),
                },
                {
                    width: 120,
                    text: "상태",
                    value: "state",
                    cellClass: "px-1",
                },
                {
                    width: +60,
                    text: "",
                    value: "actions",
                },
            ].map((item, index, array) => ({ ...item, divider: index != array.length - 1, cellClass: (item.cellClass || "") + " caption", formatter: item.formatter ?? ((value) => value ?? "-") }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, recruitments } = await api.console.recruitments.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.recruitments = recruitments.map((item, index) => ({ index: summary.totalCount - (this.page - 1) * this.limit - index, ...item }));
            } finally {
                this.loading = false;
            }
        },

        async update(recruitment) {
            if (this.loading) return;
            else this.loading = true;

            try {
                recruitment = (await api.console.recruitments.put(recruitment))?.recruitment;
                this.updateItem(recruitment);
            } finally {
                this.loading = false;
                this.search();
            }
        },

        updateItem(recruitment) {
            const index = this.recruitments.findIndex(({ _id }) => _id == recruitment._id);
            if (0 <= index) this.recruitments.splice(index, 1, recruitment);
            else {
                this.recruitments = [recruitment, ...this.recruitments];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .max-width-0 {
        max-width: 0;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
}
</style>
